<template>
  <v-app>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <router-view name="Header"></router-view>
    <div>
      <router-view />
    </div> 
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { VApp, VOverlay, VProgressCircular } from 'vuetify/lib';
import AuthService from "@/services/AuthService";
import LocalStorageService from '@/services/LocalStorageService';

export default {
  name: "App",
  components:{
    VApp, VOverlay, VProgressCircular
  },
  computed: {
    ...mapState({
      overlay: state => state.ui.overlay,
      user: state => state.session.user,
      loadingPage: state => state.session.loadingPage
    }),
    routeName() {
      return this.$route.name
    }
  },
  mounted() {
  
    const elem2 = document.getElementById("scrolling-techniques-7");
    if(elem2)
      elem2.scrollTop = 0;
    setInterval(function(){
        AuthService.setCurrentKeepAlive();
    }, 600000);
    if(!this.user) {
      this.$store.dispatch('setUserAction');
    }
  },
  watch: {
    routeName(val) {
      if(
        val != 'EmergencyContact' && val != 'RegisterEventLegacy' && 
        val != 'RidersCreate' && val != 'SpectatorsCreate' && 
        val != 'MembershipRegistration' && val != 'EventWaiverCreate'
      ) {
        LocalStorageService.setItem('active_event_registration',false);
      }
      this.$store.dispatch('setLoadingPageAction', true);
      const elem2 = document.getElementById("scrolling-techniques-7");
      if(elem2)
        elem2.scrollTop = 0;
    },
    loadingPage() {}
  },
  methods: {}
};
</script>

<style>
html { overflow-y: hidden !important; }
.showAlert{
  display:inherit;
}
.showNot{
  display: none;
}
@media (max-width: 599px) {
  .v-snack__wrapper {
    max-width: 100% !important;
    min-width: 0 !important;
    width: max-content !important;
  }
  .v-snack__wrapper .v-snack__content {
    max-width: 100%;
  }
}
</style>
<style lang='scss'>
@import "~vue-tabulator/dist/scss/tabulator_site";
.v-data-table {
  tr.v-data-table__mobile-table-row {
    td.v-data-table__mobile-row {
      min-height: 32px;
    }
  }
}
</style>
